import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/styles';
import {
  CHILDREN_PROPTYPES,
  BUTTON_COMPONENT_PROPTYPES
} from 'bento-ordering/base/constants/propTypes';

const styles = theme => ({
  containedPrimary: {
    '& .MuiButton-label': {
      transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1)'
    },
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
      '& .MuiButton-label': {
        color: '#fff'
      }
    }
  },
  disabled: {
    '&&': {
      color: theme.palette.primary.contrastText,
      opacity: 0.5
    }
  }
});

const PrimaryCta = ({
  handleClick,
  label,
  to,
  href,
  fullWidth,
  className,
  classes,
  disabled,
  component,
  type,
  dataTestId
}) => {
  return (
    <Button
      fullWidth={fullWidth}
      component={component}
      variant="contained"
      color="primary"
      onClick={handleClick}
      to={to}
      href={href}
      className={className}
      classes={classes}
      disabled={disabled}
      type={type}
      data-testid={dataTestId}
    >
      {label}
    </Button>
  );
};

PrimaryCta.defaultProps = {
  onClick: () => {},
  fullWidth: false,
  type: 'button'
};

PrimaryCta.propTypes = {
  handleClick: PropTypes.func,
  label: CHILDREN_PROPTYPES,
  to: PropTypes.string,
  href: PropTypes.string,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  classes: PropTypes.object,
  className: PropTypes.string,
  component: BUTTON_COMPONENT_PROPTYPES,
  type: PropTypes.string,
  dataTestId: PropTypes.string
};

export default withStyles(styles)(PrimaryCta);
